import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import { HeaderPage } from "../../components/Admin";
import { useBackup } from "../../hooks";
import { RestoreBackup } from "./RestoreBackup";

export function BackupAdmin() {
  const { loading, downloadBackup } = useBackup();

  const onDownload = async () => {
    try {
      await downloadBackup();
      toast.success("Respaldo descargado");
    } catch (error) {
      console.error(error);
      toast.error("No se pudo generar el respaldo. Intenta de nuevo.");
    }
  };

  return (
    <>
      <HeaderPage title="Respaldo" />

      <div style={{ maxWidth: 520 }}>
        <div
          style={{
            display: "flex",
            gap: 12,
            padding: "14px 16px",
            marginBottom: 28,
            backgroundColor: "#fdf4ec",
            borderLeft: "4px solid #e67e22",
            borderRadius: 4,
          }}
        >
          <Icon name="clock outline" size="large" style={{ color: "#e67e22" }} />
          <div>
            <h4 style={{ margin: "0 0 6px" }}>Respaldo automático</h4>
            <p style={{ margin: "0 0 6px" }}>
              Cada noche, a las 4:00 AM, el sistema se respalda
              solo, sin que tengas que hacer nada: la base de datos y las
              fotos.
            </p>
            <p style={{ margin: 0 }}>Se guardan los respaldos de los últimos 7 días.</p>
          </div>
        </div>

        <h4 style={{ margin: "0 0 6px" }}>Respaldo manual</h4>
        <p>
          Si quieres una copia tuya en este momento, descarga toda la
          información del sistema (mesas, pedidos, pagos, productos) en un solo
          archivo, sin interrumpir el funcionamiento del local. Guárdalo en un
          USB, disco externo o en la nube.
        </p>

        <Button primary loading={loading} onClick={onDownload}>
          <Icon name="download" /> Descargar respaldo ahora
        </Button>
      </div>

      <div style={{ maxWidth: 760 }}>
        <RestoreBackup />
      </div>
    </>
  );
}
